import { render, staticRenderFns } from "./FormOfOne.vue?vue&type=template&id=f19de160&scoped=true&"
import script from "./FormOfOne.vue?vue&type=script&lang=js&"
export * from "./FormOfOne.vue?vue&type=script&lang=js&"
import style0 from "./FormOfOne.vue?vue&type=style&index=0&id=f19de160&lang=less&scoped=true&"
import style1 from "./FormOfOne.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19de160",
  null
  
)

export default component.exports